import styled from 'styled-components'

export const SubTitle = styled.p`
  color: ${({ theme }) => theme.cor66};
  font-size: 16px;
  margin: 0;
`

export const CheckboxAndRadioWrapper = styled.div`
  display: grid;
  gap: 12px;
  margin-top: 20px;

  .mantine-Radio-label {
    font-weight: 400;
  }
`

export const DatePickerWrapper = styled.div`
  display: grid;
  gap: 8px;
  margin-top: 8px;
  grid-template-columns: 1fr 1fr;
`

export const BotoesWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  gap: 10px;
`
